// extracted by mini-css-extract-plugin
export var container = "thirdsColorBlock-module--container--h-eUr";
export var section = "thirdsColorBlock-module--section--VKsY5";
export var sectionInner = "thirdsColorBlock-module--sectionInner--Pe64L";
export var body = "thirdsColorBlock-module--body--puuA2";